import { ROUTE_CYCLES_TYPES } from "./routeCyclesTypes";

const {
  LOAD_ROUTE_CYCLES,
  SET_ROUTE_CYCLES,
  NEW_ROUTE_CYCLE,
  SET_NEW_ROUTE_CYCLE,
  SET_EDITED_ROUTE_CYCLE,
  EDIT_ROUTE_CYCLE,
  CLEAR_ROUTE_CYCLES,
  DELETE_ROUTE_CYCLE,
  HANDLE_ROUTE_CYCLES_INPUTS
} = ROUTE_CYCLES_TYPES;

const initialState = {
  isLoadingPage: false,
  routeCycles: [],
  routes: [],
  employees: [],
  routesMap: {},
  collectPeriods: [],
  collectPeriodsMap: [],
  station: null,

  //edit
  isAddMode: false,
  isDeleteMode: false,
  editRoute: null,

  config: {
    pageSize: 10,
    page: 0,
    sorted: [],
    filtered: []
  }
};

export const routeCyclesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case HANDLE_ROUTE_CYCLES_INPUTS:
      return {
        ...state,
        [payload.key]: payload.value
      };
    case LOAD_ROUTE_CYCLES:
      return {
        ...state,
        isLoadingPage: true
      };

    case SET_ROUTE_CYCLES:
      return {
        ...state,
        isLoadingPage: false,
        routeCycles: payload.routeCycles,
        routes: payload.routes,
        employees: payload.employees,
        routesMap: payload.routesMap,
        collectPeriods: payload.collectPeriods,
        collectPeriodsMap: payload.collectPeriodsMap
      };

    case EDIT_ROUTE_CYCLE:
      return {
        ...state,
        isAddMode: false,
        isDeleteMode: false,
        editRoute: payload
      };

    case NEW_ROUTE_CYCLE:
      return {
        ...state,
        isAddMode: true,
        isDeleteMode: false
      };

    case SET_NEW_ROUTE_CYCLE: {
      const newRouteCycles = [payload, ...state.routeCycles];

      return {
        ...state,
        routeCycles: newRouteCycles
      };
    }

    case SET_EDITED_ROUTE_CYCLE: {
      const newRouteCycles = [...state.routeCycles];
      const indexToEdit = newRouteCycles.findIndex(
        routeCycle => routeCycle.id === payload.id
      );

      if (indexToEdit !== -1) {
        newRouteCycles[indexToEdit] = payload;
      }

      return {
        ...state,
        routeCycles: newRouteCycles
      };
    }

    case DELETE_ROUTE_CYCLE:
      return {
        ...state,
        isAddMode: false,
        isDeleteMode: true
      };

    case CLEAR_ROUTE_CYCLES:
      return {
        ...state,
        ...initialState
      };

    default:
      return state;
  }
};
